import { useEffect } from "react";

export const useDelayedInput = (watch: any[], callback: () => void, delay: number) => {
  useEffect(() => {
    const timer: ReturnType<typeof setTimeout> = setTimeout(() => {
      callback();
    }, delay);
    return () => clearTimeout(timer);
  }, watch);
};
